module.exports = __webpack_public_path__ + "img/police_motorcycle_h.03adecb6.png";